import { render, staticRenderFns } from "./count-up-item.vue?vue&type=template&id=e0435020&scoped=true&"
import script from "./count-up-item.ts?vue&type=script&lang=ts&"
export * from "./count-up-item.ts?vue&type=script&lang=ts&"
import style0 from "./count-up-item.scss?vue&type=style&index=0&id=e0435020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0435020",
  null
  
)

export default component.exports